import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { automationsClient } from '#pplx_generated/typespec/rest/automations/client.js';
const GET_AUTOMATION_PATH = '/rest/automations/{automation_id}';
/** Save paths invalidate this key so a mounted sidebar or reopened editor never shows stale editor metadata. */
export function getAutomationAdmissionQueryKey(automationId) {
    return QueryClientHelper.makeQueryKey(`${GET_AUTOMATION_PATH}#admission`, automationId);
}
/** Deny by default: an unknown future gating value must not enable the editor. */
export function isAdmissionRuleEditable(gating) {
    return gating === 'explicit' || gating === 'implicit' || gating === 'available';
}
const fetchAutomationAdmission = async (automationId) => {
    const { data, error, response } = await automationsClient.GET(GET_AUTOMATION_PATH, 'fetch-automation-admission', {
        params: { path: { automation_id: automationId }, query: { runs_limit: 1 } },
        timeoutMs: getQueryTimeoutMs(),
        numRetries: 1,
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to fetch automation editor metadata',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return {
        admission_instructions: data.admission_instructions ?? null,
        admission_gating: data.admission_gating ?? null,
        model_selection: {
            model_preference: data.model_preference ?? null,
            automatic_model_preference: data.automatic_model_preference ?? null,
            effort_mode: data.effort_mode ?? null,
            reasoning_effort: data.reasoning_effort ?? null,
        },
    };
};
/**
 * The editor's semantic admission and model metadata, read over
 * REST so optional metadata does not couple the editor to new GraphQL fields.
 */
export function useAutomationAdmission({ automationId, enabled = true, }) {
    return useQuery({
        queryKey: getAutomationAdmissionQueryKey(automationId),
        queryFn: () => fetchAutomationAdmission(automationId),
        enabled: enabled && automationId !== '',
        // the rule changes only through the edit modal, which refreshes queries on
        // save; a short window keeps reopened pages fresh without per-render fetches
        staleTime: 30_000,
    });
}
//# sourceMappingURL=useAutomationAdmission.js.map